import styled from 'styled-components';

export const SameRowWithTooltip = styled.div`
  display: flex;
  align-items: center;
  margin-right: -12px;
`;

export const LabelTooltip = styled.h4`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px;
`;
